import styled from 'styled-components'
import { BREAKPOINTS } from 'styles/constants'

export const HeaderBar = styled.div`
  height: 48px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  color: var(--p-neutral-100);
  background-color: var(--p-neutral-900);

  @media (min-width: ${BREAKPOINTS.medium}) {
    display: none;
  }
`

export const HeaderBurger = styled.button`
  cursor: pointer;
  width: 48px;
  height: 48px;
  color: var(--p-neutral-100);
  display: flex;
  align-items: center;
  justify-content: center;
`
